import { Navigate } from "react-router";
import { LoginCallback } from "@okta/okta-react";

import NotFound from "pages/NotFound";

import LoginLoading from "features/auth/Login/LoginLoading";

import { lazyRoutePage } from "services/lazyRoutePage";
import { RouteConfig } from "services/routesConfig";

import { RouteKey, routes } from "./routes";

const DeveloperPortal = lazyRoutePage(
  () => import("pages/Docs/DeveloperPortal")
);
const NewTenant = lazyRoutePage(() => import("./pages/NewTenant"));
const Tenants = lazyRoutePage(() => import("./pages/Tenants"));

type RoutesConfig = Record<RouteKey, RouteConfig>;

export const routesConfig: RoutesConfig = {
  [RouteKey.LoginCallback]: {
    path: routes.loginCallback,
    insecure: true,
    component: <LoginCallback loadingElement={<LoginLoading />} />,
  },
  [RouteKey.Root]: {
    path: routes.root,
    component: <Navigate to={routes.tenants} />,
  },
  [RouteKey.Tenants]: {
    path: routes.tenants,
    component: <Tenants />,
  },
  [RouteKey.NewTenant]: {
    path: routes.newTenant,
    component: <NewTenant />,
  },
  [RouteKey.Docs]: {
    path: routes.docs,
    component: <DeveloperPortal />,
  },
  [RouteKey.NotFound]: {
    path: routes.notFound,
    component: <NotFound />,
  },
};
